import { createAsyncThunk } from '@reduxjs/toolkit';
import apiCall from 'utils/api';
import { ISkillState } from './types';

export const fetchSkills = createAsyncThunk(
  'skill/fetchSkills',
  async ({ search }: { search: string }, { rejectWithValue }) => {
    try {
      const response = await apiCall<{ data: ISkillState }>('get', `/auth/skill/search/?search=${search}`);
      return response.data.data;
    } catch (error: any) { // eslint-disable-line @typescript-eslint/no-explicit-any
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch skills');
    }
  }
)